import { render, staticRenderFns } from "./rosteringPlan.vue?vue&type=template&id=6ae288a4&scoped=true&"
import script from "./rosteringPlan.vue?vue&type=script&lang=js&"
export * from "./rosteringPlan.vue?vue&type=script&lang=js&"
import style0 from "./rosteringPlan.vue?vue&type=style&index=0&id=6ae288a4&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae288a4",
  null
  
)

export default component.exports